export default __webpack_public_path__ + "static/johnDexheimer-91cafbccad7da51d706c525ef5208430.jpg";